export * from "./IconLabel";
